import React, { Component } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { withGlobalContext } from '../../App';
import './main.scss';

class Main extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.element,
      PropTypes.func,
    ]).isRequired,
    className: PropTypes.string,
    shrinkSidebar: PropTypes.bool,
  };

  render() {
    return (
      <main
        className={cx('main mt-16', {
          shrink_main: !this.props.shrinkSidebar,
        })}>
        <div
          className={cx(
            'main__content px-4 py-8 m-auto',
            this.props.className
          )}>
          {this.props.children}
        </div>
      </main>
    );
  }
}

export default  withGlobalContext(Main);
